function findItemByUrl(array: any[], url: string): { item: any; index: number } | null {
  for (let i = 0; i < array.length; i++) {
    if (array[i].url === url) {
      return { item: array[i], index: i };
    }
  }
  return null;
}

export default findItemByUrl;